export const getComponentName = (...components: any[]) => {
	return components.map((c) => c.displayName || c.name || 'Component').join(', ');
};
